export const FAILED = 'CustomerSubmissionUnblock/failed';
export const LOADING = 'CustomerSubmissionUnblock/loading';
export const SUCCESS = 'CustomerSubmissionUnblock/success';
export const ACTION = 'CustomerSubmissionUnblock/action';
export const RESET = 'CustomerSubmissionUnblock/reset';
export const RESET_ALL = 'CustomerSubmissionUnblock/reset-all';
